export default __webpack_public_path__ + "static/media/temperance.bb2762d5.png";